module.exports = __webpack_public_path__ + "img/bell2.900806ba.svg";